/**
 * @deprecated Import from office-ui-fabric-react package instead.
 */
export * from 'office-ui-fabric-react/lib/Separator';
